import {verifyMagicLink} from "./actions/verifyMagicLink";
import {sendMagicLink} from "./actions/sendMagicLink";
import {AppStore} from "../useAppPullState";
import {useEffect} from "react";
import {createAuthHandler} from "./actions/authHandler";
import {httpsFunctions} from "../api/Api";
import {forgotPassword} from "./actions/forgotPassword";
import {loginViaEmail} from "./actions/loginViaEmail";
import {loginViaToken} from "./actions/loginViaToken";
import {signOut} from "./actions/signOut";
import {syncWithServer} from "../components/actions/syncWithServer";
import {getAuth, signInWithCustomToken} from "firebase/auth";
import {firebaseApp} from "./model/firebaseApp";

export const useAuth = () => {
    useEffect(() => {
         createAuthHandler((user) => {
            if (user) {
                httpsFunctions.post('/getUser', {
                        uid: user.uid
                    }
                )
                    .then(async (result) => {
                        const userData = result.data;
                        await AppStore.update(s => {
                           // console.log("[[useAuth]] user", userData);
                            s.user = userData;
                            s.loginPage = false;
                        });
                        setTimeout(() => {
                            syncWithServer()
                        }, 500)
                    }).catch((error) => {
                    console.error(error);
                })
            }
        });
    }, [])
}

export const firebaseService = {
    verifyMagicLink,
    sendMagicLink,
    forgotPassword,
    loginViaEmail,
    loginViaToken,
    viaToken: async (token) => {
        const auth = getAuth(firebaseApp);
        await signInWithCustomToken(auth, token)
    },
    signOut,
}
